module.exports = __webpack_public_path__ + "static/media/default.f065b10c.png";